import {Button, Modal} from 'antd'
import {course_getCourseEnrollmentsByOwner_Api, course_getTeachers_Api, courseEnrollment_getById_Api,} from 'apis'
import {LayoutContext} from 'components/layouts/Default/LayoutContext'
import _ from 'lodash'
import Async from 'modules/asyncCache/components/Async'
import useTranslate from 'modules/local/useTranslate'
import {useHistory} from 'modules/navigation/useRouter'
import React, {useCallback, useContext, useEffect, useMemo, useState,} from 'react'
import {useLocation} from 'react-use'
import {branch, compose} from 'recompose'
import {ContentNotFound} from 'views/AppLocals/ContentNotFound'
import {CourseActionTypes, enrollment_status_options,} from 'views/AppLocals/Course'
import {useCourse} from 'views/AppLocals/Course/useCourse'
import {showDeleteConfirmDialog} from 'views/AppLocals/factory/createConfirmDialog'
import createContextMenu from 'views/AppLocals/factory/createContextMenu'
import {bindQueryParam, bindQueryParams,} from 'views/AppLocals/functions/routerHelper'
import usePaginationHelper, {createPagerKey,} from 'views/AppLocals/hooks/usePaginationHelper'
import {getResponseItem, NullAsDefault} from 'views/Shared'
import {CourseApproveModal} from '../components/CourseApproveModal'
import CourseEnrollmentFilter from '../components/filters/CourseEnrollmentFilter'
import {DetailEnrollmentModalContent, enrollmentGotoUrl, renderCourseEnrollmentCardItem, renderCourseEnrollmentTableRow} from '../functions/renderCourseEnrollment'
import {IoWarning} from "react-icons/io5";
import {BiTrash} from "react-icons/bi";
import {PiCheckCircle, PiXCircle} from "react-icons/pi";
import {BsGrid3X3GapFill, BsTable} from "react-icons/bs";
import classNames from "classnames";
import {copyLocationParam, getRouteSearchParams, useRouteSearchParam} from "../../../../envs/_current/history";
import LoadingBlock from "../../../Loading/LoadingBlock";
import PagePaginationWrapper from "../../../../modules/asyncCache/components/PagePagination/PagePaginationWrapper";
import {renderTeacher} from "../functions/renderTeacher";
import {renderLoading} from "../../../AppLocals/functions/renderers/renderLoading";
import EmptyHolder from "../../../../components/EmptyHolder";
import {HiArrowRight} from "react-icons/hi2";

const CourseEnrollments = ({
                               owner_id,
                               owner_type,
                               filter_actions = {
                                   status: 'status',
                                   sortBy: 'sort-by',
                                   keyword: 'keyword',
                                   course_id: 'course-id',
                               },
                           }) => {
    const t = useTranslate()
    const {isLg} = useContext(LayoutContext)
    const history = useHistory()
    const location = useLocation()
    const sortBy = useRouteSearchParam(filter_actions.sortBy)
    const status = useRouteSearchParam(filter_actions.status)
    const course_id = useRouteSearchParam(filter_actions.course_id)
    const [action, setAction] = useState({
        type: undefined,
        value: undefined,
    })

    // Bảng mặc định, chuyển sang Thẻ qua toggle - local state, không vào URL.
    const [viewMode, setViewMode] = useState('table')

    // Modal "Xem chi tiết" cục bộ cho action mắt (danh sách không có sẵn flow này).
    const [detailItem, setDetailItem] = useState(null)
    const onViewDetail = useCallback((item) => setDetailItem(item ?? null), [])
    const detailGotoUrl = detailItem ? enrollmentGotoUrl(detailItem, owner_id) : null

    const onCancel = () => {
        setAction({})
    }

    let timeout
    useEffect(() => {
        const searchParams = getRouteSearchParams()
        searchParams.set(
            filter_actions.status,
            enrollment_status_options.pending.value
        )
        timeout = setTimeout(() => {
            history.replace({
                ...copyLocationParam(window.location ?? {}),
                search: '?' + searchParams.toString(),
            })
        })
        return () => clearTimeout(timeout)
    }, [])

    const {
        refreshKey,
        onReject = NullAsDefault,
        onApprove = NullAsDefault,
        onDeleteEnrollment = NullAsDefault,
    } = useCourse({
        onRejected: onCancel,
        onApproved: onCancel,
        onEnrollmentDeleted: onCancel,
    })

    const confirmReject = (id) => {
        if (id) {
            showDeleteConfirmDialog({
                icon: <IoWarning className="anticon"/>,
                translate: t,
                title: 'reject student',
                message: 'are you sure you want to reject this student',
                onOk: () => {
                    onReject({}, {id})
                },
            })
        }
    }

    const confirmDelete = (id) => {
        if (id) {
            showDeleteConfirmDialog({
                translate: t,
                onOk: () => {
                    onDeleteEnrollment({}, {id})
                },
            })
        }
    }

    const handleAction = (action, params) => {
        const course_id = params?.id
        switch (action) {
            case CourseActionTypes.ENROLLMENT_APPROVE:
                setAction({type: action, value: params})
                break
            case CourseActionTypes.ENROLLMENT_REJECT:
                confirmReject(course_id)
                break
            case CourseActionTypes.ENROLLMENT_DELETE:
                confirmDelete(course_id)
                break
            default:
                break
        }
    }

    const refresh_deps = useMemo(
        () => [
            owner_id,
            owner_type,
            refreshKey,
            `refreshToken=${_.get(location.state, 'refreshToken')}`,
        ],
        [owner_id, owner_type, refreshKey, location.state]
    )

    // Bảng: HỌC VIÊN | KHÓA HỌC ĐĂNG KÝ | GIỚI TÍNH & NGÀY SINH | NGÀY ĐĂNG KÝ & TRẠNG THÁI |
    // THAO TÁC - khớp renderCourseEnrollmentTableRow. Không có cột "mã đơn".
    const TABLE_COLUMNS = [
        {label: t('student'), className: 'text-left'},
        {label: t('contact'), className: 'text-left'},
        {label: t('registered course'), className: 'text-left'},
        {label: `${t('gender')} /\n ${t('date of birth')}`, className: 'text-left'},
        {label: `${t('enrollment date')} /\n ${t('status')}`, className: 'text-left'},
        {label: t('actions'), className: 'text-right'},
    ]

    const renderList = useCallback(
        ({keyword, sortBy: currentSort, filterBy, refreshKey}) => (
            <PagePaginationWrapper
                apiInfo={course_getCourseEnrollmentsByOwner_Api}
                query={bindQueryParams([{id: owner_id}, {type: owner_type}])}
                values={{keyword, sort_by: currentSort, status, ...(filterBy ?? {})}}
                refreshKey={refreshKey}
                renderItem={
                    viewMode === 'table'
                        ? renderCourseEnrollmentTableRow({translate: t, owner_id, onView: onViewDetail})
                        : renderCourseEnrollmentCardItem({translate: t, owner_id, onView: onViewDetail})
                }
                renderLoading={() => renderLoading()}
                renderEmpty={() => <EmptyHolder/>}
                Wrapper={({children}) => viewMode === 'table' ? (
                    <div className="mt-2 w-full overflow-x-auto rounded-xl border border-color-50">
                        <table className="w-full" style={{borderCollapse: 'collapse'}}>
                            <thead>
                                <tr className="background-200">
                                    {TABLE_COLUMNS.map((col, i) => (
                                        <th
                                            key={i}
                                            className={classNames(
                                                "px-3 py-2 text-2xs font-bold text-color-400 uppercase tracking-wider whitespace-pre-line",
                                                col.className)}>
                                            {col.label}
                                        </th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>{children}</tbody>
                        </table>
                    </div>
                ) : (
                    <div className="mt-2 grid grid-cols-1 md:grid-cols-2 gap-3">
                        {children}
                    </div>
                )}
            />
        ),
        [owner_id, owner_type, t, status, viewMode, onViewDetail]
    )

    const viewModeToggle = (
        <div className="flex items-center flex-shrink-0 rounded-lg border border-color-200 overflow-hidden">
            <button
                type="button"
                title={t('table')}
                onClick={() => setViewMode('table')}
                style={{width: 40, height: 40}}
                className={classNames(
                    "flex flex-center transition-colors",
                    viewMode === 'table' ? 'bg-secondary-500 text-white' : 'background text-color-300 hover:text-secondary-600'
                )}>
                <BsTable size={14}/>
            </button>
            <button
                type="button"
                title={t('card')}
                onClick={() => setViewMode('card')}
                style={{width: 40, height: 40}}
                className={classNames(
                    "flex flex-center transition-colors border-l border-color-200",
                    viewMode === 'card' ? 'bg-secondary-500 text-white' : 'background text-color-300 hover:text-secondary-600'
                )}>
                <BsGrid3X3GapFill size={14}/>
            </button>
        </div>
    )

    const [pager_widget] = usePaginationHelper({
        filter_params: {
            owner_id,
            owner_type,
        },
        onInit: ({onSortChange = NullAsDefault, onFilterChange = NullAsDefault}) => {
            onFilterChange({
                status,
                course_id,
            })
            onSortChange(sortBy)
        },
        renderList,
        // Toggle Bảng/Thẻ đặt giữa ô search và nút Lọc - không đụng CourseEnrollmentFilter / search.
        renderHeader: ([search_bar]) => (
            <div className="flex items-center gap-2">
                <div className="flex-1 min-w-0">{search_bar}</div>
                {viewModeToggle}
            </div>
        ),
        SortByWidget: NullAsDefault,
        renderSortBy: NullAsDefault,
        isToggleDefault: true,
        query_params: filter_actions,
        dependencies: [owner_id, owner_type],
        withKey: createPagerKey(refresh_deps),
        AdvancedFilter: CourseEnrollmentFilter,
    })

    return (
        <div className="flex flex-col gap-3 222-222">
            <div className="flex flex-col flex-1">
                <h2 className="font-bold text-xl text-gray-800 tracking-wide">
                    {t('enrollments')}
                </h2>
                <div className="my-1 w-20 h-1 rounded-full bg-gray-400"/>
                <div className="mt-1 text-sm text-color-300 tracking-wider">
                    {t('registers for course description')}
                </div>
            </div>
            {pager_widget}
            {/*{modal}*/}
            <Modal
                open={!!detailItem}
                onCancel={() => setDetailItem(null)}
                destroyOnHidden={true}
                width={600}
                className="custom-modal"
                title={
                    <div className="text-center font-bold text-color-000 uppercase tracking-wide">
                        {t('view detail')}
                    </div>
                }
                footer={[
                    <Button
                        key="close"
                        onClick={() => setDetailItem(null)}
                        className="text-color-200 button-rounded-lg no-border">
                        {t('close')}
                    </Button>,
                    detailGotoUrl && (
                        <Button
                            key="goto"
                            type="primary"
                            className="button-rounded-lg"
                            onClick={() => {
                                setDetailItem(null)
                                history.push(detailGotoUrl)
                            }}>
                            {t('go to enrollment page')}
                            <HiArrowRight size={13}/>
                        </Button>
                    ),
                ].filter(Boolean)}>
                {detailItem && <DetailEnrollmentModalContent item={detailItem}/>}
            </Modal>
            <div className="h-16"/>
        </div>
    )
}

export default compose(
    branch(
        ({owner_id, owner_type}) => _.some([owner_id, owner_type], _.isEmpty),
        () => () => <ContentNotFound/>
    )
)(CourseEnrollments)
